var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"7ee88f2"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';

Sentry.init({
  environment: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT,
  dsn: 'https://865758f170f9ede773ff5a4fa47d624c@o665977.ingest.us.sentry.io/4508765660315648',
  enabled: process.env.NODE_ENV !== 'development',
  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 1,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,

  // replaysOnErrorSampleRate: 1.0,

  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  // replaysSessionSampleRate: 0.1,

  // You can remove this option if you're not planning to use the Sentry Session Replay feature:
  integrations: [
    // Sentry.replayIntegration({
    //   // Additional Replay configuration goes in here, for example:
    //   maskAllText: true,
    //   blockAllMedia: true,
    // }),
  ],

  // Filter Sentry error logs
  beforeSend(event) {
    if (event.exception?.values) {
      const exceptionMessages = event.exception.values.map(v => v.value);

      const wordsToCheck = [
        '#418',
        '#423',
        '#425',
        "(setting 'onclick')",
        'sendtogoogleanalytics',
        'Hydration',
        'querySelector',
        'shouldEnforce',
      ];

      // Check if the error message contains any of the words
      const containsHydration = exceptionMessages.some(message =>
        wordsToCheck.some(word =>
          message?.toLowerCase().includes(word.toLowerCase())
        )
      );

      // Helper function to check if `gtm.js` appears in stack trace
      const hasIgnoredFile = stacktrace =>
        stacktrace?.frames?.some(
          frame =>
            frame.filename?.includes('gtm.js') ||
            frame.abs_path?.includes('gtm.js')
        );

      // Check both `stacktrace` and `raw_stacktrace`
      const containsGtmFile = event?.exception?.values?.some(
        exception =>
          hasIgnoredFile(exception?.stacktrace) ||
          //@ts-ignore
          hasIgnoredFile(exception?.raw_stacktrace)
      );

      // console.warn(
      //   '📌 Sentry ===>',
      //   `"containsHydration"-${containsHydration},
      //   "exceptionMessages"-${exceptionMessages},
      //   "containsGtmFile"-${containsGtmFile}`
      // );

      if (containsHydration || containsGtmFile) {
        return null; // Explicitly return null to prevent sending this event
      }
    }

    return event; // Return the event if not filtered
  },
});

// console.warn(
//   '🚀 ~ <======== client.config.ts :=====>',
//   `process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT-${process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT}`
// );
